import type { Milliseconds } from '@lemonade-hq/ts-helpers';
import _, { type DebouncedFunc } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';

// TODO: monolu!

interface Props {
  changingValue: unknown;
  duration: Milliseconds;
  condition?: boolean;
}

export default function useValueAtRest({ changingValue, duration, condition }: Props): boolean {
  const [result, setResult] = useState(condition ?? true);
  const debouncedSetAtRest = useRef<null | DebouncedFunc<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args: any) => unknown
  >>(null);

  debouncedSetAtRest.current = useCallback(
    _.debounce(() => {
      setResult(true);
    }, duration),
    [],
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    setResult(false);
    if (condition == null || condition) {
      debouncedSetAtRest.current?.();
    }
  }, [changingValue]);

  useEffect(() => {
    return () => {
      debouncedSetAtRest.current?.cancel();
    };
  }, []);

  return result;
}
